import { navColumnCss, stickyNavCss } from './sticky_chrome';
import { TabNav, tabId, tabPanelId } from '../components/tab_nav';
import { ActiveTabPanels } from '../tabs/active_tab_panels';
const bodyCss = "bjpha8w";
const contentCss = "cftys0";
export const MediumLayout = ({
  activeTab,
  tabs,
  onSelectTab,
  etLocks,
  invalidTabKeys,
  lockingDisables,
  panelKeys,
  panelPropsByKey
}) => <div className={bodyCss}>
    <div className={navColumnCss}>
      <TabNav tabs={tabs} activeTabKey={activeTab.key} onSelectTab={onSelectTab} invalidTabKeys={invalidTabKeys} className={stickyNavCss} />
    </div>
    <main className={contentCss} role="tabpanel" id={tabPanelId(activeTab.key)} aria-labelledby={tabId(activeTab.key)}>
      <ActiveTabPanels tabKey={activeTab.key} etLocks={etLocks} lockingDisables={lockingDisables} panelKeys={panelKeys} panelPropsByKey={panelPropsByKey} />
    </main>
  </div>;

require("./medium_layout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./medium_layout.js");